/**
 * Status indicator for database connections
 */

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { ConnectionStatus } from '@/types/discovery'

interface ConnectionStatusBadgeProps {
  readonly status: ConnectionStatus
  readonly className?: string
}

const statusConfig: Record<
  ConnectionStatus,
  { label: string; dotClass: string; badgeClass: string }
> = {
  ACTIVE: {
    label: 'Connected',
    dotClass: 'bg-green-500',
    badgeClass:
      'border-green-500/30 bg-green-500/10 text-green-700 dark:text-green-400',
  },
  INACTIVE: {
    label: 'Not Tested',
    dotClass: 'bg-yellow-500',
    badgeClass:
      'border-yellow-500/30 bg-yellow-500/10 text-yellow-700 dark:text-yellow-400',
  },
  ERROR: {
    label: 'Error',
    dotClass: 'bg-red-500',
    badgeClass: 'border-red-500/30 bg-red-500/10 text-red-700 dark:text-red-400',
  },
}

export function ConnectionStatusBadge({
  status,
  className,
}: ConnectionStatusBadgeProps) {
  const config = statusConfig[status]

  return (
    <Badge variant="outline" className={cn(config.badgeClass, className)}>
      <span className={cn('mr-1.5 h-2 w-2 rounded-full', config.dotClass)} />
      {config.label}
    </Badge>
  )
}
